import { postClosingOptionListApis } from 'app/services/api';

import { POST_CLOSING_OPTION_LIST_TYPES } from 'constants/postClosingOptions';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const POST_CLOSING_OPTIONS_ACTION_TYPE = createNamedActions('postClosingOptions', {
  GET_OPTIONS: 'GET_OPTIONS',
  GET_ADMIN_OPTIONS: 'GET_ADMIN_OPTIONS',
});

const getPostClosingOptionsByListTypeAction = catchAsyncActionError(
  ({ listType, skipDeduplication }) =>
    async dispatch => {
      const { data } = await postClosingOptionListApis[listType].getOptions({ skipDeduplication });

      return dispatch({
        type: POST_CLOSING_OPTIONS_ACTION_TYPE.GET_OPTIONS,
        payload: data,
        meta: { listType },
      });
    },
);

const getAdminPostClosingOptionsByListTypeAction = catchAsyncActionError(
  ({ listType }) =>
    async dispatch => {
      const { data } = await postClosingOptionListApis[listType].getAdminOptions();

      return dispatch({
        type: POST_CLOSING_OPTIONS_ACTION_TYPE.GET_ADMIN_OPTIONS,
        payload: data,
        meta: { listType },
      });
    },
);

export const getPostClosingOptionsAction = () => dispatch =>
  Promise.allSettled(
    POST_CLOSING_OPTION_LIST_TYPES.map(listType =>
      dispatch(getPostClosingOptionsByListTypeAction({ listType, silent: true })),
    ),
  );

export const getAdminPostClosingOptionsAction =
  ({ listType }) =>
  dispatch =>
    Promise.all([
      dispatch(getAdminPostClosingOptionsByListTypeAction({ listType })),
      dispatch(getPostClosingOptionsByListTypeAction({ listType, skipDeduplication: true })),
    ]);

export const createPostClosingOptionAction = catchAsyncActionError(
  ({ listType, displayName, value, sortOrder }) =>
    async dispatch => {
      await postClosingOptionListApis[listType].createOption({ displayName, value, sortOrder });

      return dispatch(getAdminPostClosingOptionsAction({ listType }));
    },
);

const editPostClosingOption = ({ listType, option: { id, displayName, sortOrder } }) =>
  postClosingOptionListApis[listType].editOption({ id, displayName, sortOrder });

export const editPostClosingOptionsAction = catchAsyncActionError(
  ({ listType, options }) =>
    async dispatch => {
      const [firstOption, ...remainingOptions] = options;

      try {
        await editPostClosingOption({ listType, option: firstOption });

        if (remainingOptions.length) {
          const {
            data: { items: companyOptions },
          } = await postClosingOptionListApis[listType].getAdminOptions();

          await Promise.all(
            remainingOptions.map(option =>
              editPostClosingOption({
                listType,
                option: {
                  ...option,
                  id: companyOptions.find(({ value }) => value === option.value)?.id ?? option.id,
                },
              }),
            ),
          );
        }
      } finally {
        await dispatch(getAdminPostClosingOptionsAction({ listType })).catch(Error);
      }
    },
);

export const deletePostClosingOptionAction = catchAsyncActionError(
  ({ listType, id }) =>
    async dispatch => {
      await postClosingOptionListApis[listType].deleteOption({ id });

      return dispatch(getAdminPostClosingOptionsAction({ listType }));
    },
);
